import { useMemo } from 'react'

import { DefaultLayout } from '~/shared/layouts'
import { useAppSelector } from '~/redux/hooks'
import { selectUserId } from '~/auth/slices/auth.slice'
import { EventType } from '~/behavior-tracking/types'
import CurriculumOverview from '~/curriculum/components/CurriculumOverview'
import { selectGradeContent, selectIsJuniorMathGrade } from '~/curriculum/slice/curriculum.slice'
import { useGetCurriculumLastActivityQuery } from '~/curriculum/apis/get-curriculum-user-stats.api'

export default function CurriculumGradePage(): React.ReactElement {
  const isJuniorMathGrade = useAppSelector(selectIsJuniorMathGrade)
  const userId = useAppSelector(selectUserId)
  const gradeData = useAppSelector(selectGradeContent)

  const lastActivity = useGetCurriculumLastActivityQuery(
    { eventName: EventType.CURRICULUM_TOPIC_EVENT },
    {
      skip: !userId,
    },
  ).data
  const isJuniorGradeOnboarding =
    !!userId && !!lastActivity && lastActivity?.subjectOrder === -1 && gradeData.gradeLevel < 5

  const hideTopbar = useMemo(() => {
    if (gradeData.gradeLevel > 4) return false
    return !lastActivity || isJuniorGradeOnboarding
  }, [lastActivity, isJuniorGradeOnboarding, gradeData.gradeLevel])

  return (
    <DefaultLayout dashboardGradientClass={isJuniorMathGrade ? 'bg-gradient-blue-dark' : ''} hideTopbar={hideTopbar}>
      <CurriculumOverview isJuniorGradeOnboarding={isJuniorGradeOnboarding} />
    </DefaultLayout>
  )
}
